<template>
    <div>
        <div v-if="!disablePreview" class="row" style="margin: 0px!important;">
            <div v-for="(file, i) in computedFiles" :key="i" class="float-left" style="position: relative">
                <app-loader-gif v-if="!file.file"/>
                <span v-show="file.file && !disablePreview" class="mdi mdi-24px mdi-trash-can-outline trash-img" @click="removeFile(file.id)"/>
                <img v-show="file.file && imgMimes.includes(file.type) && !disablePreview"
                     :src="file.file"
                     width="160px"
                     height="auto"
                     class="img-thumbnail"
                     :class="{'ml-2':i > 0}"/>
                <img v-show="!imgMimes.includes(file.type) && !disablePreview" width="100px" src="~@assets/img/unknown_file.png" alt=""/>
                <p :class="{'ml-2':i > 0}">{{ file.name | truncate }}</p>
            </div>
        </div>
        <div :class="{'mt-2': !disablePreview}" :style="wrapperStyles">
            <input type="file" @change="onChange" :style="fileInputStyles" :accept="accept" :multiple="multiple"/>
            <input type="text" :class="inputClass" :style="textInputStyles" :placeholder="$t(placeholder)" disabled />
        </div>
    </div>
</template>

<script>
export default {
    name: 'AppUpload',
    props: {
        inputClass: {
            type: String,
            default: ''
        },
        accept: {
            type: String,
            default: 'image/png,image/gif,image/jpeg'
        },
        maxSize: {
            type: Number,
            default: 10 // megabytes
        },
        disablePreview: {
            type: Boolean,
            default: false
        },
        multiple: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: 'Click here to choose files'
        }
    },
    data() {
        return {
            files: [],
            maxMbSize: 10,
            imgMimes: [
                'image/png',
                'image/gif',
                'image/jpeg'
            ]
        };
    },
    computed: {
        wrapperStyles() {
            return {
                position: 'relative',
                width: '100%'
            };
        },
        fileInputStyles() {
            return {
                width: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                opacity: 0,
                overflow: 'hidden',
                outline: 'none',
                cursor: 'pointer'
            };
        },
        textInputStyles() {
            return {
                width: '100%',
                cursor: 'pointer'
            };
        },
        computedFiles() {
            return this.files;
        }
    },
    methods: {
        onChange(e) {
            const files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            if(!this.multiple) {
                const file = files[0];
                this.checkSize(file);
                this.files = [];
                this.files.push({
                    id: 1,
                    name: file.name,
                    size: file.size,
                    type: file.type,
                    file: null
                });

                const reader = new FileReader();
                reader.onload = e => {
                    const dataURI = e.target.result;
                    if (dataURI) {
                        this.$emit('load', dataURI);
                        this.files[0].file = dataURI;
                    }
                };
                reader.readAsDataURL(file);

                this.$emit('file', this.files[0]);
            } else {
                for(let i = 0; i < files.length; i++) {
                    this.checkSize(files[i]);
                    let file = {
                        id: this.computedFiles.length + 1,
                        name: files[i].name,
                        size: files[i].size,
                        type: files[i].type,
                        file: null
                    };
                    this.computedFiles.push(file);

                    const reader = new FileReader();
                    reader.onload = e => {
                        const dataURI = e.target.result;
                        if (dataURI) {
                            file.file = dataURI;
                        }
                    };
                    reader.readAsDataURL(files[i]);
                }
                this.$emit('files', this.computedFiles);
            }
        },
        checkSize(file) {
            const size = file.size && (file.size / Math.pow(1000, 2));
            if (size > this.maxSize) {
                this.$emit('size-exceeded', size);
                return;
            }
        },
        removeFile(fileId) {
            if(!this.multiple) {
                const index = this.computedFiles.findIndex(file => file.id === fileId);
                this.files.splice(index, 1);
                this.$emit('remove');
            } else {
                const index = this.computedFiles.findIndex(file => file.id === fileId);
                this.$emit('remove', index);
            }
        }
    }
};
</script>
